export const CHECK_CODE_WITH_LOCATION = "checkCodeWithLocation";
export const CHECK_FOR_MEETING = "checkForMeeting";
export const CHECK_FOR_ROOMS = "checkForRooms";
export const CHECK_MEETING_FOR_VLAN = "checkMeetingForVlan";
export const DOES_MAC_EXIST = "doesMacExist";
export const GET_MEETING = "getMeeting";
export const GET_MEETING_ROOMS = "getMeetingRooms";
export const GET_SPLASH_PAGE = "getSplashPage";
export const ADD_USER = "addUser";
export const APPLY_ACCESS_CODE = "applyAccessCode";
export const CREATE_SESSION = "createSession";
export const GET_AUTHENTICATION_ZONE_BY_LOCATION = "getAuthenticationZoneByLocation";
export const APPLY_TITLE = 'applyTitle';
export const APPLY_TEMPLATE = 'applyTemplate';
export const APPLY_ERROR = 'applyError';
export const GET_TEMPLATE_METHOD_VARIABLES = 'getTemplateMethodVariables';
export const GET_ENTITY = 'getEntity';
export const APPLY_TEMPLATE_PATH = 'applyTemplatePath';
export const APPLY_VIEW_TYPE = 'applyViewType';
export const APPLY_BLOCKED_VIEW_TYPE = 'applyBlockedViewType';
export const APPLY_MEETING_VIEW_TYPE = 'applyMeetingViewType';
export const APPLY_NOMEETING_VIEW_TYPE = 'applyNomeetingViewType';
export const APPLY_SESSION_VIEW_TYPE = 'applySessionViewType';
export const APPLY_TRANSPORT_VIEW_TYPE = 'applyTransportViewType';
export const APPLY_WELCOME_VIEW_TYPE = 'applyWelcomeViewType';
export const GET_MEETING_MOTD = 'getMeetingMotd';